import { Svg } from './svg'

export const SchedulingAssistantIcon = () => (
  <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.4168 10.4167C15.8376 10.4167 16.1892 10.6887 16.3169 11.0604L16.3397 11.1361L16.395 11.3265C16.7037
        12.2675 17.4797 12.9986 18.4474 13.2439C18.8572 13.3476 19.1668 13.7179 19.1668 14.1667C19.1668 14.6154
        18.8571 14.9849 18.4474 15.0887C17.4152 15.3503 16.6004 16.1651 16.3388 17.1973C16.2351 17.607 15.8656
        17.9167 15.4168 17.9167C14.9681 17.9167 14.5986 17.607 14.4948 17.1973C14.2332 16.1651 13.4184 15.3503
        12.3862 15.0887C12.0021 14.9914 11.7055 14.6605 11.6701 14.2497L11.6668 14.1667L11.6701 14.0837C11.7055
        13.6728 12.0021 13.3412 12.3862 13.2439C13.4182 12.9823 14.2324 12.1681 14.494 11.1361C14.5977 10.7264
        14.9681 10.4167 15.4168 10.4167ZM13.3335 1.66669C14.254 1.66669 15.0002 2.41288 15.0002
        3.33335V8.75002H13.3335V5.55585L9.09358 7.8174C8.35833 8.20956 7.47536 8.20956 6.74007 7.8174L2.50016
        5.55585V10.8334H10.0002V12.5H2.50016C1.57969 12.5 0.833496 11.7539 0.833496 10.8334V3.33335C0.833496 2.41288
        1.57969 1.66669 2.50016 1.66669H13.3335ZM2.50016 3.6662L7.52458 6.34605C7.76967 6.47677 8.06399 6.47677
        8.30908 6.34605L13.3335 3.6662V3.33335H2.50016V3.6662Z"
      fill="currentColor"
    />
  </Svg>
)
